import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import getCSSSelector_1 from '../../../../../libraries/Images/getCSSSelector_1.png';
import getCSSSelector_2 from '../../../../../libraries/Images/getCSSSelector_2.png';
import getCSSSelector_3 from '../../../../../libraries/Images/getCSSSelector_3.png';
import getCSSSelector_4 from '../../../../../libraries/Images/getCSSSelector_4.png';

import makeYourFirstRobot_1 from '../../../../../libraries/Images/makeYourFirstRobot_1.png';
import makeYourFirstRobot_2 from '../../../../../libraries/Images/makeYourFirstRobot_2.png';
import makeYourFirstRobot_3 from '../../../../../libraries/Images/makeYourFirstRobot_3.gif';
import makeYourFirstRobot_4 from '../../../../../libraries/Images/makeYourFirstRobot_4.png';
import makeYourFirstRobot_5 from '../../../../../libraries/Images/makeYourFirstRobot_5.png';
import makeYourFirstRobot_6 from '../../../../../libraries/Images/makeYourFirstRobot_6.png';
import makeYourFirstRobot_7 from '../../../../../libraries/Images/makeYourFirstRobot_7.png';

import runYourRobot_1 from '../../../../../libraries/Images/runYourRobot_1.png';
import runYourRobot_2 from '../../../../../libraries/Images/runYourRobot_2.png';

import scheduleRobotRun_1 from '../../../../../libraries/Images/scheduleRobotRun_1.png';
import scheduleRobotRun_2 from '../../../../../libraries/Images/scheduleRobotRun_2.png';
import scheduleRobotRun_3 from '../../../../../libraries/Images/scheduleRobotRun_3.png';
import scheduleRobotRun_4 from '../../../../../libraries/Images/scheduleRobotRun_4.png';
import scheduleRobotRun_5 from '../../../../../libraries/Images/scheduleRobotRun_5.png';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="getcssselector">
                1. {translate('getcssselector')}
            </Typography>
            <p>Các bộ chọn CSS được sử dụng để xác định vị trí các phần tử HTML trên các trang web.</p>
            <p>Bằng cách dựa vào các bộ chọn CSS mà chúng ta có thể thực hiện các thao tác trên trang web thông qua RPA CLOUD.</p>
            <p>Trước tiên, bạn cần cài đặt tiện ích mở rộng có tên RPA CLOUD trong Chrome. Vui lòng xem <Box component={Link} to='/control-center/documentation/gettingstarted/installation/#chrome-extension'>tại đây</Box> để biết hướng dẫn cài đặt.</p>
            <p>Quy trình:</p>
            <ol>
                <li>Mở trang hiển thị phần tử bạn muốn lấy bộ chọn CSS.</li>
                <p>Ví dụ bạn mở trang <a href="https://www.amazon.com/" target="_blank">https://www.amazon.com/</a>.</p>
                <Zoom>
                    <img src={getCSSSelector_1} width="75%" />
                </Zoom>
                <li>Nhấp chuột phải vào phần tử bạn muốn lấy.</li>
                <p>Đối tượng bạn cần lấy bộ chọn CSS là ô [Tìm kiếm] thì chỉ cần di chuyển đến vị trí [Ô tìm kiếm] và nhấp chuột phải vào đó.</p>
                <Zoom>
                    <img src={getCSSSelector_2} width="75%" />
                </Zoom>
                <li>Nhấp vào menu ngữ cảnh [Copy CSS Selector].</li>
                <p>Sau khi nhấp vào [Copy CSS Selector] thì đối tượng sẽ hiện lên viền bao quanh màu xanh. Viền màu xanh này báo hiệu việc lấy bộ chọn CSS đã thành công.</p>
                <Zoom>
                    <img src={getCSSSelector_3} width="75%" />
                </Zoom>
                <li>Dán Bộ chọn CSS đã sao chép và kiểm chứng kết quả.</li>
                <p>Cuối cùng là dán vào trình soạn thảo văn bản (Windows: [Ctrl] + [V] / Mac: [Command] + [V]), bạn có thể thấy rằng bộ chọn CSS đã được lấy thành công.</p>
                <Zoom>
                    <img src={getCSSSelector_4} width="75%" />
                </Zoom>
            </ol>
            <Typography variant="h5" gutterBottom id="makeyourfirstrobot">
                2. {translate('makeyourfirstrobot')}
            </Typography>
            <p>Ví dụ bạn sẽ tạo ra 1 robot tự động tìm kiếm iphone trên trang web Amazon.</p>
            <p>Quy trình:</p>
            <ol>
                <li>Đầu tiên nhấp vào <a href="/control-center/workspace" target="_blank">đây</a> để tạo robot.</li>
                <li>Nhấp vào nút [Thêm mới] và nhập các trường như hình bên dưới:</li>
                <ul style={{ listStyle: "none" }}>
                    <Zoom>
                        <img src={makeYourFirstRobot_1} width="75%" />
                    </Zoom>
                    <li>❶&nbsp;Chọn tên [Dự án]. Nếu bạn chưa có dự án nào thì hãy nhấp vào nút ➕ (❶a) bên phải để khởi tạo dự án mới.</li>
                    <li>❷&nbsp;Nhập tên Robot.</li>
                    <li>❸&nbsp;Chọn biểu tượng cho robot.</li>
                    <li>❹&nbsp;Chọn màu nền cho robot.</li>
                    <li>❺&nbsp;Chọn màu cho biểu tượng robot.</li>
                    <li>❻&nbsp;Chọn có bật thông báo gửi mail khi robot xảy ra lỗi hay không.</li>
                    <li>❼&nbsp;Nhập mô tả về robot.</li>
                    <p>Cuối cùng là nhấp vào nút [OK] để hoàn tất.</p>
                </ul>
                <li>Sau khi khởi tạo xong thì màn hình sẽ hiển thị 1 thẻ (mỗi một thẻ thẻ sẽ đại diện cho một robot).</li>
                <p>Tiếp tục nhấp vào biểu tượng cờ lê để vào màn hình soạn thảo kịch bản cho robot.</p>
                <Zoom>
                    <img src={makeYourFirstRobot_2} width="75%" />
                </Zoom>
                <li>Tạo hành động [Mở trình duyệt].</li>
                <p>Nắm kéo và thả thẻ hành động [Mở trình duyệt].</p>
                <Zoom>
                    <img src={makeYourFirstRobot_3} width="75%" />
                </Zoom>
                <p>Chỉ định đường dẫn khi mở trình duyệt.</p>
                <p>Nhấp vào biểu tượng bánh răng để mở hộp tuỳ chọn, sau đó nhập đường dẫn của trang Amazon vào trường [Url], cuối cùng là nhấp vào nút [Lưu].</p>
                <Zoom>
                    <img src={makeYourFirstRobot_4} width="75%" />
                </Zoom>
                <li>Tạo hành động [Nhập văn bản].</li>
                <p>Nhập giá trị tìm kiếm vào ô tìm kiếm trên trang Amazon.</p>
                <ul style={{ listStyle: "none" }}>
                    <Zoom>
                        <img src={makeYourFirstRobot_5} width="75%" />
                    </Zoom>
                    <li>❶&nbsp;Nắm kéo và thả thẻ hành động [Nhập văn bản].</li>
                    <li>❷&nbsp;Nhấp vào biểu tượng bánh răng để mở hộp tuỳ chọn.</li>
                    <li>❸&nbsp;Chỉ định nhập văn bản cho trình duyệt nào (trường hợp bạn đang mở nhiều trình duyệt thì mỗi trình duyệt sẽ cho bạn 1 output key).</li>
                    <li>❹&nbsp;Mở trang Amazon copy bộ chọn CSS và dán vào.</li>
                    <li>❺&nbsp;Nhập văn bản cần tìm kiếm (ví dụ như là iphone 13 pro max).</li>
                    <p>Cuối cùng là nhấp vào nút [Lưu]</p>
                </ul>
                <li>Tạo hành động [Nhấp chuột].</li>
                <p>Nhấp chuột vào nút tìm kiếm trên trang Amazon.</p>
                <ul style={{ listStyle: "none" }}>
                    <Zoom>
                        <img src={makeYourFirstRobot_6} width="75%" />
                    </Zoom>
                    <li>❶&nbsp;Nắm kéo và thả thẻ hành động [Nhấp chuột].</li>
                    <li>❷&nbsp;Nhấp vào biểu tượng bánh răng để mở hộp tuỳ chọn.</li>
                    <li>❸&nbsp;Chỉ định nhập văn bản cho trình duyệt nào (trường hợp bạn đang mở nhiều trình duyệt thì mỗi trình duyệt sẽ cho bạn 1 output key).</li>
                    <li>❹&nbsp;Mở trang Amazon copy bộ chọn CSS và dán vào.</li>
                    <p>Cuối cùng là nhấp vào nút [Lưu]</p>
                </ul>
                <li>Lưu kịch bản của robot.</li>
                <p>Nhấp chuột vào nút [Lưu] để lưu kịch bản robot. Lưu ý nếu bạn không bấm lưu thì kịch bản sẽ mất khi bạn tải lại trang web.</p>
                <Zoom>
                    <img src={makeYourFirstRobot_7} width="75%" />
                </Zoom>
            </ol>
            <Typography variant="h5" gutterBottom id="runyourrobot">
                3. {translate('runyourrobot')}
            </Typography>
            <p>Bạn có thể kiểm tra kịch bản có được thực hiện tốt hay không bằng cách chạy thử kịch bản.</p>
            <p>Quy trình:</p>
            <ol>
                <li>Nhấp vào nút [Chạy] để chạy kịch bản.</li>
                <Zoom>
                    <img src={runYourRobot_1} width="75%" />
                </Zoom>
                <li>Kiểm tra kết quả trả về.</li>
                <p>Đối với các thao tác được thực hiện trên trình duyệt thì kết quả sẽ kèm theo hình ảnh nếu bạn chọn [Ảnh chụp màn hình].</p>
                <Zoom>
                    <img src={runYourRobot_2} width="75%" />
                </Zoom>
                <p>Để quay lại màn hình soạn thảo kịch bản nhấp vào biểu tượng ✖️ phía trên bên phải.</p>
            </ol>
            <Typography variant="h5" gutterBottom id="schedulerobotrun">
                4. {translate('schedulerobotrun')}
            </Typography>
            <p>Bạn có thể đặt lịch chạy robot theo ý mình.</p>
            <p>Quy trình:</p>
            <ol>
                <li>Nhấp vào <a href="/control-center/schedule" target="_blank">đây</a> để đặt lịch chạy robot.</li>
                <li>Nhấp vào nút [Thêm mới] để tạo lịch chạy.</li>
                <p>Sau đó chọn tên robot muốn đặt lịch và nhấp vào nút [Tiếp theo]</p>
                <Zoom>
                    <img src={scheduleRobotRun_1} width="75%" />
                </Zoom>
                <li>Chọn múi giờ và chọn ngày giờ khởi chạy robot sau đó nhấp vào nút [Tiếp theo].</li>
                <Zoom>
                    <img src={scheduleRobotRun_2} width="75%" />
                </Zoom>
                <li>Xác nhận lại thông tin lịch chạy và nhấp vào nút [OK].</li>
                <Zoom>
                    <img src={scheduleRobotRun_3} width="75%" />
                </Zoom>
                <li>Sau khi khởi tạo xong thì màn hình sẽ hiển thị 1 dòng (mỗi một dòng sẽ là một lịch chạy).</li>
                <Zoom>
                    <img src={scheduleRobotRun_4} width="75%" />
                </Zoom>
                <p>Để kiểm tra lại lịch sử chạy hoặc xóa lịch chạy bạn có thể tích vào đối tượng lịch trình như hình bên dưới.</p>
                <Zoom>
                    <img src={scheduleRobotRun_5} width="75%" />
                </Zoom>
            </ol>
        </Box>
    );
}
export default withTranslate(Vi);